import { FC } from "react";
import { Box } from "@mui/material";
import { useStyles } from "./styles";

interface Props {
  year: string;
  title: string;
  subtitle: string;
  text: string;
  direction: string;
  squarePos?: string;
  hasBottomTriangle?: boolean;
  inMobile: boolean;
}

const TimeLineItem: FC<Props> = ({
  year,
  title,
  subtitle,
  text,
  direction,
  squarePos,
  hasBottomTriangle,
  inMobile,
}) => {
  const classes = useStyles();

  if (inMobile) {
    return (
      <Box className={classes.container}>
        <Box className={classes.main}>
          <Box className={classes.subtitle}>{subtitle}</Box>
          <Box className={classes.title}>{title}</Box>
          <Box className={classes.text}>{text}</Box>
        </Box>
        <Box className={classes.yearContainer}>
          <Box className={classes.year}>{year}</Box>
          <Box className={classes.mobileTriangle} />
        </Box>
      </Box>
    );
  }

  if (direction === "bottom") {
    return (
      <Box className={classes.containerBottom}>
        <Box className={classes.yearBottom}>{year}</Box>
        <Box className={classes.subtitleBottom}>{subtitle}</Box>
        <Box className={classes.titleBottom}>{title}</Box>
        <Box className={classes.textBottom}>{text}</Box>
      </Box>
    );
  }

  return (
    <Box
      className={`${classes.container} ${
        squarePos === "bottom" ? classes.borderBottom : ""
      } ${hasBottomTriangle ? classes.extraPaddingBottom : ""}`}
      flexDirection={direction === "left" ? "row" : "row-reverse"}
    >
      <Box
        className={`${classes.main} ${
          squarePos === "bottom" ? classes.bottomSpace : ""
        }`}
      >
        <Box className={classes.subtitle}>{subtitle}</Box>
        <Box className={classes.title}>{title}</Box>
        <Box className={classes.text}>{text}</Box>
      </Box>
      <Box
        className={
          direction === "left" ? classes.divider : classes.dividerReversed
        }
      >
        {squarePos && (
          <Box
            className={classes.square}
            sx={{
              top: squarePos === "top" ? "-8px" : "auto",
              bottom: squarePos === "bottom" ? "-8px" : "auto",
            }}
          ></Box>
        )}
        {hasBottomTriangle && <Box className={classes.bottomTriangle} />}
      </Box>
      <Box className={classes.yearContainer}>
        <Box className={classes.year}>{year}</Box>
      </Box>
    </Box>
  );
};

export default TimeLineItem;
